import React, { useState } from "react";
import Logo from "../assets/Logo.png";
import { headerLinks } from "../utils";
import Button from "./Button";
import { HiMenuAlt3 } from "react-icons/hi";
const Header = () => {
  const [active, setActive] = useState(false);
  return (
    <div>
      <div className="container py-4">
        <div className=" flex  justify-between items-center">
          <div>
            <img src={Logo} alt="" />
          </div>
          <ul className=" hidden md:flex justify-center text-gray">
            {headerLinks.map((val, i) => (
              <li key={i} className="p-2 px-4">
                <a href="https://google.com">{val.text}</a>
              </li>
            ))}
          </ul>
          <div className=" hidden md:block">
            <Button>ENTER APP</Button>
          </div>

          <button
            className="md:hidden text-2xl"
            onClick={() => setActive((prev) => !prev)}
          >
            <HiMenuAlt3 />
          </button>
          <div
            className={`md:hidden fixed top-[70px] overflow-hidden left-[2%] w-[96%] transition-all duration-500 bg-dark-500 rounded-lg ${
              active ? "max-h-[100vh]" : "max-h-[0]"
            } `}
          >
            <div className="py-10">
              <ul className=" text-center text-gray">
                {headerLinks.map((val, i) => (
                  <li key={i} className="p-2 px-4">
                    <a href="https://google.com">{val.text}</a>
                  </li>
                ))}
              </ul>
              <div className=" mx-auto flex justify-center">
                <Button>ENTER APP</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
